<template>
	<section>
		<content-container>
			<article class="add-new-item">
				<p class="add-new-item-title">Special Item</p>
				<div style="margin-top: 10px">
					<span class="ghost-item-title">
						<input
							class="ghost-item-title-box"
							title="Name of new item"
							placeholder="Name Of Item"
							type="text"
							name="gname"
							maxlength="60"
							style="width: 145px; margin-left: 10px"
							v-model="newItemName"
							ref="itemInput"
						/>
					</span>
					<span class="ghost-item-price">
						$
						<input
							class="ghost-item-price-box"
							type="text"
							name="gprice"
							title="Price of new item"
							maxlength="6"
							style="width: 45px"
							v-model.trim="newItemPrice"
						/>
					</span>
					<!-- end menu-item-price -->
				</div>
				<div class="menu-item-description" style="margin: 10px">
					<textarea
						class="ghost-textarea"
						title="Who is this for?"
						placeholder="Who is this for?"
						rows="1"
						cols="20"
						v-model="whofor"
					></textarea>
				</div>
				<div class="menu-item-description" style="margin: 10px">
					<textarea
						class="ghost-textarea"
						:title="'Special Instructions for ' + restName"
						:placeholder="'Special Instructions for ' + restName"
						rows="2"
						cols="20"
						v-model="specInstructions"
					></textarea>
				</div>
				<div class="menu-item-order">
					<label for="item-order" class="item-order-label">Set Item Qty:</label>
					<input v-model="newItemQty" type="text" id="item-order" title="item order" />
					<i class="fas fa-angle-double-up" v-tooltip="maxToolTip" @click="increaseQuantity()"></i>
					<i class="fas fa-angle-double-down" v-tooltip="minToolTip" @click="decreaseQuantity()"></i>
					<input
						class="menu-item-addbtn"
						type="image"
						name="submit"
						:src="$CDN + '/style/btn-add.gif'"
						title="add new item to group"
						v-tooltip="addItemToolTip"
						@click.prevent="submit()"
					/>
					<i v-show="showSpinner" class="fas fa-spinner fa-spin fa-3x"></i>
				</div>
			</article>
		</content-container>
	</section>
</template>

<script>
import { mapActions } from "vuex";
import ContentContainer from "./ContentContainer.vue";

export default {
	components: {
		ContentContainer,
	},
	props: {
		restId: String,
		restName: String,
	},
	data: function () {
		return {
			newItemName: "",
			specInstructions: "",
			whofor: "",
			newItemPrice: "",
			newItemQty: 1,
			showSpinner: false,
		};
	},
	computed: {
		maxToolTip: function () {
			if (this.newItemName.length > 0) {
				return "Increase quantity for " + this.newItemName;
			}
			return "Increase quantity for this item.";
		},
		minToolTip: function () {
			if (this.newItemName.length > 0) {
				return "Decrease quantity for  " + this.newItemName;
			}
			return "Decrease quantity for this item.";
		},
		addItemToolTip: function () {
			if (this.newItemName.length > 0) {
				return "Add " + this.newItemName + " to the cart.";
			}
			return "Add special item to the cart.";
		},
	},
	methods: {
		...mapActions({
			addSpecialItem: "restMenu/addSpecialItem",
		}),
		increaseQuantity() {
			this.newItemQty++;
		},
		decreaseQuantity() {
			if (this.newItemQty > 1) {
				this.newItemQty--;
			}
		},
		submit: async function () {
			if (this.newItemQty < 1 || isNaN(this.newItemQty)) {
				this.$toasted.show("Invalid item quantity. Please set item quantity to at least 1.", {
					action: {
						text: "DISMISS",
						onClick: (e, toastObject) => {
							toastObject.goAway(0);
						},
					},
				});
				return false;
			}
			this.showSpinner = true;
			if (this.newItemPrice === "") {
				this.newItemPrice = 0.0;
			}
			await this.addSpecialItem({
				price: this.newItemPrice,
				name: this.newItemName,
				specInstructions: this.specInstructions,
				restId: this.restId,
				qty: this.newItemQty,
				whofor: this.whofor,
			});
			this.newItemName = "";
			this.specInstructions = "";
			this.newItemPrice = "";
			this.newItemQty = 1;
			this.whofor = "";
			this.$refs.itemInput.focus();
			this.showSpinner = false;
		},
	},
};
</script>
<style lang="scss" scoped>
#item-order {
	width: 30px;
}
.item-order-label {
	font-weight: 300;
	margin-left: 10px;
}
.menu-item-addbtn {
	margin-left: 10px;
}
.add-new-item {
	border-radius: 4px;
	box-shadow: 1px 1px 5px 0 rgba(171, 168, 168, 0.5);
	max-width: 100%;
	padding: 5px;
	margin-bottom: 20px;
	@media (min-width: $tabletPortrait) {
		max-width: 47%;
		padding-right: 20px;
	}

	@media (min-width: $tabletLandscape) {
		max-width: 31.5%;
	}
}
.add-new-item-title {
	font-weight: 900;
}
.section {
	margin-bottom: $section-spacing;
}
.fa-angle-double-up,
.fa-angle-double-down {
	cursor: pointer;
}
</style>
